import {mainQuery} from '@github-ui/react-core/future/main-query'

import {blackbirdSearchAppBuilder} from '../config/app-builder'
import type {HomePayload, SearchResults} from '../types/blackbird-types'

export const blackbirdSearchRoute = blackbirdSearchAppBuilder.createQueryRouteConfig('blackbirdSearchRoute', {
  path: '/search',
  queries: [
    mainQuery<SearchResults | HomePayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
    }),
  ],
})
